if (!customElements.get('tms-order-swatches')) {
  customElements.define('tms-order-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.selected = new Set();
      this.inCart = new Set();
      this.cartCount = 0;
      this.busy = false;
      this.cartReady = false;
      this.cards = [...this.querySelectorAll('[data-variant]')];
      this.msg = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.add = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.preview = this.dataset.preview === 'true';
      this.base = window.Shopify?.routes?.root || '/';
      this.cards.forEach(card => card.dataset.available = String(!card.disabled));
      [...new Set(this.cards.map(c => c.dataset.family))].forEach(family => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.filter = family; button.textContent = family;
        button.setAttribute('aria-pressed', 'false'); this.querySelector('[data-filters]').append(button);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || this.busy) return;
        if (button.hasAttribute('data-filter')) {
          this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          this.cards.forEach(c => c.hidden = button.dataset.filter !== 'all' && c.dataset.family !== button.dataset.filter);
        }
        if (button.hasAttribute('data-variant') && !button.disabled) {
          const id = button.dataset.variant;
          if (this.selected.has(id)) this.selected.delete(id);
          else if (this.selected.size + this.cartCount < 4) this.selected.add(id);
          else { this.status.textContent = this.msg.limit; return; }
          this.status.textContent = ''; this.render();
        }
        if (button.hasAttribute('data-add')) this.submit();
        if (button.hasAttribute('data-back')) this.querySelector('[data-filters]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      this.onFocus = () => { if (!this.busy && !this.preview) this.refresh().then(() => this.render()).catch(() => this.fail()); };
      window.addEventListener('focus', this.onFocus);
      this.render();
      if (this.preview) { this.cartReady = true; this.render(); }
      else this.refresh().then(() => this.render()).catch(() => this.fail());
    }
    disconnectedCallback() { window.removeEventListener('focus', this.onFocus); }
    async refresh() {
      const response = await fetch(this.base + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      const lines = cart.items.filter(item => String(item.product_id) === this.dataset.productId);
      this.cartCount = lines.reduce((n,item) => n + item.quantity, 0);
      this.inCart = new Set(lines.map(item => String(item.variant_id)));
      this.inCart.forEach(id => this.selected.delete(id));
      this.cartReady = true;
    }
    render() {
      this.cards.forEach(card => {
        const id = card.dataset.variant;
        card.disabled = this.busy || this.inCart.has(id) || card.dataset.available === 'false';
        card.dataset.inCart = String(this.inCart.has(id));
        card.setAttribute('aria-pressed', String(this.selected.has(id) || this.inCart.has(id)));
        if (card.dataset.available !== 'false') card.querySelector('[data-card-label]').textContent = this.inCart.has(id) ? this.msg.in_cart : this.selected.has(id) ? this.msg.selected : this.msg.select;
      });
      this.querySelector('[data-count]').textContent = this.msg.count.replace('[selected]',this.selected.size).replace('[cart]',this.cartCount);
      this.querySelector('[data-names]').textContent = this.cards.filter(c => this.selected.has(c.dataset.variant)).map(c => c.dataset.name).join(' · ') || this.msg.choose;
      this.add.disabled = this.busy || !this.cartReady || !this.selected.size || this.cartCount + this.selected.size > 4;
      this.add.textContent = this.busy ? this.msg.adding : this.msg.add;
    }
    fail() { this.cartReady = false; this.status.textContent = this.msg.error; this.render(); }
    async submit() {
      if (this.busy || !this.selected.size || !this.cartReady) return;
      if (this.preview) { this.status.textContent = this.msg.preview; return; }
      this.busy = true; this.render();
      const perform = async () => {
        await this.refresh();
        if (!this.selected.size) return;
        if (this.cartCount + this.selected.size > 4) { this.status.textContent = this.msg.limit; return; }
        const items = [...this.selected].map(id => ({id:Number(id),quantity:1}));
        const response = await fetch(this.base + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if (!response.ok) { const error = await response.json().catch(() => ({})); throw new Error(error.description || this.msg.error); }
        this.selected.clear();
        window.location.assign(this.dataset.cartUrl);
      };
      try { if (navigator.locks) await navigator.locks.request('tms-swatch-cart',perform); else await perform(); }
      catch (error) { this.status.textContent = error.message || this.msg.error; }
      finally { this.busy = false; this.render(); }
    }
  });
}
